import { emojiFree } from "./UITheme.js";

/**
 * Theme-aware iconography. In the default/kenney themes we use the familiar
 * emoji; in the Relikara theme (emoji-free) we swap in clean arcane SVG line
 * icons that inherit the text colour. `gi(name)` returns whichever the active
 * theme wants; call it wherever a glyph string is built.
 */
const svg = (paths) =>
  `<svg class="gi" viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:-0.14em">${paths}</svg>`;

// name → { e: emoji, s: svg }
const MAP = {
  sword:   { e: "⚔️", s: svg('<path d="M14 3h7v7"/><path d="M21 3 11 13"/><path d="m5 21 4-1 2-2-3-3-2 2-1 4Z"/><path d="m9 15-2-2"/>') },
  bow:     { e: "🏹", s: svg('<path d="M5 3a13 13 0 0 1 0 18"/><path d="M5 3 21 19"/><path d="M15 19h6v-6"/>') },
  staff:   { e: "🔮", s: svg('<circle cx="12" cy="6" r="3"/><path d="M12 9v12"/>') },
  axe:     { e: "🪓", s: svg('<path d="M14 3a7 7 0 0 1 5 7l-8-1Z"/><path d="m11 9-7 11"/>') },
  dagger:  { e: "🗡️", s: svg('<path d="M12 2 9 14h6L12 2Z"/><path d="M9 14h6v3H9z"/><path d="M12 17v5"/>') },
  shield:  { e: "🛡️", s: svg('<path d="M12 3 5 6v5c0 4 3 7 7 9 4-2 7-5 7-9V6l-7-3Z"/>') },
  potion:  { e: "🧪", s: svg('<path d="M10 3h4"/><path d="M11 3v6l-4 8a3 3 0 0 0 3 4h4a3 3 0 0 0 3-4l-4-8V3"/><path d="M8 15h8"/>') },
  coins:   { e: "🪙", s: svg('<ellipse cx="12" cy="7" rx="7" ry="3"/><path d="M5 7v6c0 1.7 3.1 3 7 3s7-1.3 7-3V7"/>') },
  resource:{ e: "⛏️", s: svg('<path d="M4 20 14 10"/><path d="M4 8a12 12 0 0 1 16 0"/><path d="M12 8 8 12"/>') },
  fragment:{ e: "📜", s: svg('<path d="M6 4h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4Z"/><path d="M6 4a2 2 0 0 0-2 2v0a2 2 0 0 0 2 2M9 9h6M9 13h6"/>') },
  treasure:{ e: "💎", s: svg('<path d="M6 3h12l3 5-9 13L3 8Z"/><path d="M3 8h18M9 3 7 8l5 13M15 3l2 5-5 13"/>') },
  magnet:  { e: "🧲", s: svg('<path d="M6 3v8a6 6 0 0 0 12 0V3"/><path d="M6 7h4M14 7h4"/>') },
  flame:   { e: "🔥", s: svg('<path d="M12 3c1 4 5 5 5 9a5 5 0 0 1-10 0c0-2 1-3 2-4 0 2 1 3 2 3 0-3-1-5-1-8Z"/>') },
  spark:   { e: "✦", s: svg('<path d="M12 3v18M3 12h18M6 6l12 12M18 6 6 18"/>') },
  paw:     { e: "🐾", s: svg('<circle cx="7" cy="9" r="1.6"/><circle cx="12" cy="7" r="1.6"/><circle cx="17" cy="9" r="1.6"/><path d="M8 15a4 4 0 0 1 8 0 3 3 0 0 1-8 0Z"/>') },
  anvil:   { e: "⚒️", s: svg('<path d="M4 9h11a4 4 0 0 0 4-4M7 9v3a5 5 0 0 0 5 5M8 17h8l-1 3H9Z"/>') },
  cart:    { e: "🛒", s: svg('<path d="M4 5h2l2 10h9l2-7H7"/><circle cx="9" cy="19" r="1.3"/><circle cx="17" cy="19" r="1.3"/>') },
  home:    { e: "🏠", s: svg('<path d="M4 11 12 4l8 7"/><path d="M6 10v9h12v-9"/><path d="M10 19v-5h4v5"/>') },
  book:    { e: "📖", s: svg('<path d="M12 6C10 4 6 4 4 5v13c2-1 6-1 8 1 2-2 6-2 8-1V5c-2-1-6-1-8 1Z"/><path d="M12 6v13"/>') },
  coin:    { e: "🪙", s: svg('<circle cx="12" cy="12" r="8"/><path d="M9 12h6M12 9v6"/>') },
  key:     { e: "🗝️", s: svg('<circle cx="7.5" cy="12" r="3.5"/><path d="M11 12h9M17 12v3.5M20 12v2.5"/>') },
};

export function gi(name) {
  const it = MAP[name];
  if (!it) return "";
  return emojiFree() ? it.s : it.e;
}
